var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-img",on:{"click":_vm.goToHelpPage}},[_c('img',{attrs:{"src":"/assets/img/support.svg"}}),_c('p',[_vm._v("Help?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }